import styled from 'styled-components';

export const Container = styled.div`
  border-collapse: collapse;

  .row.th {
    padding: 0 !important;

    .resizer {
      display: none;
    }
  }

  .row.th > .th {
    font-size: 14px !important;
    color: black !important;
    text-align: left;
    padding-left: 10.5px;
  }

  .td {
    font-size: 14px;
  }
`;
